import { ContextAction } from "src/util/enums/entityType"

export const DEFAULT_CONTEXT_ACTIONS: ContextAction[] = [ContextAction.HELP, ContextAction.FEEDBACK]

export const TAB_TO_DO_UNSUBMITTED_WORK = "unsubmitted-work"

export const TAB_WORK_ORDER_OVERVIEW = "overview"
export const TAB_WORK_ORDER_ISSUES = "issues"
export const TAB_WORK_ORDER_ITEMS = "items"
export const TAB_WORK_ORDER_ATTACHED = "attached"
export const TAB_WORK_ORDER_COMMENTS = "comments"
